import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import TrafikSigortasiSeo from './TrafikSigortasiSeo';
import { useNavigate } from 'react-router-dom';

const TrafikSigortasi = () => {
  const navigate = useNavigate();  // Bu satırı ekleyin

  const [formData, setFormData] = useState({
    tc: '',
    plaka: '',
    telefon: '',
    kvkk: true
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [validationErrors, setValidationErrors] = useState({});

  const agents = [
    { name: 'Kübra', title: 'Sigorta Uzmanı', image: '💁‍♀️', testimonial: "Kübra Hanım sayesinde kolayca sigorta yaptırdım." },
    { name: 'Murat', title: 'Sigorta Danışmanı', image: '👨‍💼', testimonial: "Murat Bey çok hızlı bir şekilde teklif hazırladı." },
    { name: 'Enes', title: 'Sigorta Sorumlusu', image: '👨‍💼', testimonial: "Enes Beyin ilgisi ve bilgisi çok etkileyiciydi." },
    { name: 'Rukiye', title: 'Sigorta Uzmanı', image: '👩‍💼', testimonial: "Rukiye Hanım gerçekten işinde çok profesyonel." }
  ];

  const [activeAgent, setActiveAgent] = useState(0);

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * agents.length);
    setActiveAgent(randomIndex);

    const timer = setInterval(() => {
      setActiveAgent((prev) => (prev + 1) % agents.length);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  // Form validation ve submit fonksiyonları...
  const validateForm = () => {
    const errors = {};
    
    if (!formData.tc || formData.tc.length !== 11 || !/^\d+$/.test(formData.tc)) {
      errors.tc = 'Geçerli bir TC Kimlik Numarası giriniz';
    }

    if (!formData.plaka || formData.plaka.length < 5) {
      errors.plaka = 'Geçerli bir plaka giriniz';
    }

    const phoneRegex = /^[0-9]{10,11}$/;
    if (!formData.telefon || !phoneRegex.test(formData.telefon.replace(/\D/g, ''))) {
      errors.telefon = 'Geçerli bir telefon numarası giriniz';
    }

    if (!formData.kvkk) {
      errors.kvkk = 'KVKK metnini kabul etmelisiniz';
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!validateForm()) {
      return;
    }
  
    setLoading(true);



    try {
      // ruhsatNo'yu boş string olarak ekleyerek gönderiyoruz
      const submitData = {
        ...formData,
        ruhsatNo: ''  // Veritabanı için boş değer
      };

      const response = await fetch(`${window.location.protocol}//${window.location.host}/trafik-sigortasi-teklif.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(submitData)
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.message || 'Bir hata oluştu');
      }
  
      navigate(`/tesekkurler?teklifKodu=${data.teklifKodu}`);
      
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="overflow-x-hidden">
      <Helmet>
        <title>Trafik Sigortası - En Uygun Fiyatlarla | SigortamOlsun</title>
        <meta name="description" content="Aracınız için en uygun trafik sigortası tekliflerini anında karşılaştırın." />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="canonical" href="https://sigortamolsun.com/trafik-sigortasi" />
      </Helmet>

      <div className="px-4 py-8">
        <div className="max-w-md mx-auto">
          {/* Agent Kartları */}
          <div className="relative h-32 mb-4">
            {agents.map((agent, index) => (
              <div
                key={agent.name}
                className={`absolute w-full transition-all duration-500 transform
                  ${index === activeAgent ? 'scale-100 opacity-100' : 'scale-75 opacity-0'}
                  flex items-center gap-3 bg-blue-50 p-4 rounded-xl shadow-md border-2 border-blue-200`}
                style={{
                  transform: `translateX(${(index - activeAgent) * 100}%) scale(${index === activeAgent ? 1 : 0.75})`,
                  zIndex: index === activeAgent ? 10 : 0
                }}
              >
                <span className="text-2xl sm:text-3xl flex-shrink-0">{agent.image}</span>
                <div className="min-w-0 flex-1">
                  <div className="font-semibold text-blue-900">{agent.name}</div>
                  <div className="text-sm text-blue-600">{agent.title}</div>
                  <div className="text-sm italic text-gray-500 break-words">{agent.testimonial}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Bilgilendirme */}
          <div className="text-center mb-6">
            <h1 className="text-xl sm:text-2xl font-semibold mb-4">
              Merhaba,<br />
              Ben trafik sigortası uzmanı <span className="text-blue-600">{agents[activeAgent].name}</span>.<br />
              Görevim sizin için en uygun fiyatı bulmak.
            </h1>
            <p className="text-gray-600 text-sm">
              Fiyat almak için lütfen aşağıdaki formu doldurunuz.
            </p>
          </div>

          {/* Hata ve Başarı Mesajları */}
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg">
              {error}
            </div>
          )}
          {success && (
            <div className="mb-4 p-3 bg-green-50 border border-green-200 text-green-700 rounded-lg">
              {success}
            </div>
          )}

{/* Form */}
<form onSubmit={handleSubmit} className="space-y-4">
  {/* TC Kimlik Input */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      TC Kimlik Numaranız
    </label>
              <input
                type="tel"
                placeholder="TC Kimlik Numarası"
                className={`w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600
                  ${validationErrors.tc ? 'border-red-500' : 'border-gray-300'}`}
                maxLength="11"
                value={formData.tc}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '');
                  setFormData({ ...formData, tc: value });
                  if (validationErrors.tc) {
                    setValidationErrors({ ...validationErrors, tc: '' });
                  }
                }}
              />
              {validationErrors.tc && (
                <p className="mt-1 text-sm text-red-600">{validationErrors.tc}</p>
              )}
            </div>

            <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Araç Plakanız
    </label>
              <input
                type="text"
                placeholder="Plaka"
                className={`w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600
                  ${validationErrors.plaka ? 'border-red-500' : 'border-gray-300'}`}
                value={formData.plaka}
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();
                  setFormData({ ...formData, plaka: value });
                  if (validationErrors.plaka) {
                    setValidationErrors({ ...validationErrors, plaka: '' });
                  }
                }}
              />
              {validationErrors.plaka && (
                <p className="mt-1 text-sm text-red-600">{validationErrors.plaka}</p>
              )}
            </div>

            

            <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Telefon Numaranız
    </label>
              <input
                type="tel"
                placeholder="Telefon Numarası"
                className={`w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600
                  ${validationErrors.telefon ? 'border-red-500' : 'border-gray-300'}`}
                value={formData.telefon}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '');
                  setFormData({ ...formData, telefon: value });
                  if (validationErrors.telefon) {
                    setValidationErrors({ ...validationErrors, telefon: '' });
                  }
                }}
              />
              {validationErrors.telefon && (
                <p className="mt-1 text-sm text-red-600">{validationErrors.telefon}</p>
              )}
            </div>

            <div className="flex items-start gap-2">
              <input
                type="checkbox"
                checked={formData.kvkk}
                onChange={(e) => {
                  setFormData({ ...formData, kvkk: e.target.checked });
                  if (validationErrors.kvkk) {
                    setValidationErrors({ ...validationErrors, kvkk: '' });
                  }
                }}
                className={`mt-1 ${validationErrors.kvkk ? 'border-red-500' : ''}`}
              />
              <label className="text-sm text-gray-600">
                <Link to="/kvkk" className="text-blue-600 hover:text-blue-700">KVKK</Link>
                {' ve '}
                <Link to="/aydinlatma-metni" className="text-blue-600 hover:text-blue-700">site kullanım koşullarını</Link>
                {' kabul ediyorum'}
              </label>
            </div>
            {validationErrors.kvkk && (
              <p className="text-sm text-red-600">{validationErrors.kvkk}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              className={`w-full bg-blue-600 text-white py-3 rounded-lg transition
                ${loading ? 'opacity-70 cursor-not-allowed' : 'hover:bg-blue-700'}`}
            >
              {loading ? 'Gönderiliyor...' : 'Fiyat Al'}
            </button>
          </form>
        </div>
      </div>
      <TrafikSigortasiSeo />
    </div>
  );
};

export default TrafikSigortasi;